<div class="employee-pin-modal">
  <h3 class="title">{{ 'MODAL.HEADER.EMPLOYEEPINHEADER' | translate }}</h3>

  <input
    class="pin-input"
    inputmode="numeric"
    pattern="[0-9]*"
    type="password"
    [(ngModel)]="pin"
    (ngModelChange)="onPinChange($event)"
    placeholder="{{ 'MODAL.TEXT.EMPLOYEEPININPUT' | translate }}"
  >

  @if (errorMessage()) {
    <p class="pin-error">{{ errorMessage() | translate }}</p>
  }

  <button class="submit-button" type="button" [disabled]="!pin" (click)="closeModal(pin)">OK</button>
</div>
